@switch (displayValue) {
    @case ('true') {
        <div class="statusWrapper true" [ngClass]="{ 'small-icon': isFloatingFilterIcon }">
            <i class="fas true fa-check"></i>
        </div>
    }
    @case ('false') {
        <div class="statusWrapper false" [ngClass]="{ 'small-icon': isFloatingFilterIcon }">
            <i class="fas false fa-xmark"></i>
        </div>
    }
    @default {
        <span>{{ displayValue | translate }}</span>
    }
}
